// extracted by mini-css-extract-plugin
export default {"contentContainer":"_2j2iQSSKtG6mSM7VmQfo17"};